import { applyMiddleware, combineReducers, createStore, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";
import { connectRoutes } from "redux-first-router";
import qs from "qs";

import { routesMap } from "../routes";
import AuthenticationReducer from "../modules/auth/AuthenticationState";
import EditorPanelReducer from "../vendor/signal-widgets/editorPanel/EditorPanelState";
import EndToEndReducer from "../modules/end-to-end/EndToEndState";
import EventsReducer from "../modules/events/EventsState";
import LocationsReducer from "../modules/locations/LocationsState";
import UserDataReducer from "../modules/user-data/UserDataState";
import shipmentsStatusState from "../modules/shipment-status/ShipmentsState";
import DomainDataState from "../modules/domain-data/DomainDataState";
import LadsState from "../modules/lads/LadsState";
import SearchState from "../modules/shipment-search/ShipmentSearchState";
import OrganizationsReducer from "../modules/organizations/OrganizationsState";
import MapReducer from "../modules/map/MapState";
import LocationDetailState from "../modules/location-detail/LocationDetailState";
import HeaderReducer from "../modules/header-bar/HeaderBarState";
import ProfileState from "../modules/profile/ProfileState";

import UsersReducer from "../modules/users/UsersState";
import RolesReducer from "../modules/roles/RolesState";
import CallbackReducer from "../modules/callback/CallbackState";
import SavedSearchState from "../modules/shipment-search/SavedSearchState";

const appReducers = {
  auth: AuthenticationReducer,
  callback: CallbackReducer,

  editorPanel: EditorPanelReducer,
  endToEnd: EndToEndReducer,
  events: EventsReducer,
  locations: LocationsReducer,
  organizations: OrganizationsReducer,
  maps: MapReducer,
  header: HeaderReducer,
  [ProfileState.mountPoint]: ProfileState.reducer,

  user: UserDataReducer,
  users: UsersReducer,
  roles: RolesReducer,

  [shipmentsStatusState.mountPoint]: shipmentsStatusState.reducer,
  [LadsState.mountPoint]: LadsState.reducer,
  [SearchState.mountPoint]: SearchState.reducer,
  [SavedSearchState.mountPoint]: SavedSearchState.reducer,
  [DomainDataState.mountPoint]: DomainDataState.reducer,
  [LocationDetailState.mountPoint]: LocationDetailState.reducer
};

let appMiddlewares = [thunkMiddleware];
if (!!process.env.REACT_APP_IS_LOGGING_ACTIONS) {
  appMiddlewares.push(createLogger());
}

export default function configureStore(history, preloadedState) {
  const { reducer, middleware, enhancer } = connectRoutes(history, routesMap, {
    querySerializer: qs
  });
  const appliedMiddlewares = applyMiddleware(middleware, ...appMiddlewares);
  const enhancers = compose(
    enhancer,
    appliedMiddlewares
  );
  const reducers = combineReducers({
    location: reducer,
    ...appReducers
  });
  const store = createStore(reducers, preloadedState, enhancers);
  return {
    store
  };
}



// WEBPACK FOOTER //
// ./src/redux/store.js